export default __webpack_public_path__ + "static/media/woman-abbs.1edc9e35.png";